import { Heading } from '@/components/Heading';
import { Text } from '@/components/Text';
import { shippingLines } from '@/lib/voltrShipping';
import type { VoltrProduct, VoltrShipping } from '@/types/voltr';

import { OrderSummaryCard, SummaryLines } from './OrderSummaryCard';

export type OrderReviewStepProps = {
  brandName: string;
  product: VoltrProduct;
  /** The tidied address, exactly as it will be sent. */
  shipping: VoltrShipping;
  error: string | null;
};

/**
 * Order step 3: the product and the address read back before anything is
 * sent. "Place Order" under it is the only thing that orders. (The Figma
 * stops at step 2; this is the step it counts as 3.)
 */
export function OrderReviewStep({ brandName, product, shipping, error }: OrderReviewStepProps) {
  return (
    <>
      <Heading size="3xl">Review your order</Heading>
      <OrderSummaryCard
        product={product}
        rows={[{ label: 'Ship to', value: <SummaryLines lines={shippingLines(shipping)} />, testID: 'voltr-review-ship-to' }]}
        testID="voltr-review"
      />
      <Text variant="caption" color="textMuted">
        {brandName} ships it to this address. Check it before you place the order.
      </Text>
      {error ? (
        <Text color="danger" testID="voltr-order-error-message">
          {error}
        </Text>
      ) : null}
    </>
  );
}
